export default "__VITE_ASSET__B_nX5ms5__"